import debounce from 'lodash.debounce'
export default debounce



// WEBPACK FOOTER //
// ./node_modules/vux/src/tools/debounce/index.js